<template>
  <div class="knowledge-block-articles">
    <div class="pt-3 pb-3 row justify-content-between">
      <div class="col-md-6">
        <h2>{{ title }}</h2>
      </div>
      <div class="col-md-5 text-md-right text-left"></div>
    </div>
    <div class="row">
      <div
        v-for="article in customArticles"
        class="article-container pb-4 col-lg-9"
        :key="article.id"
      >
        <div class="article-title-container mb-1">
          <div v-if="article.type == 'KNOWLEDGE'">
            <router-link
              :to="'/' + platformCategory + '/articles/' + article.id"
              @click.native="redirectToArticle(article.name)"
            >{{ article.name }}</router-link>
          </div>
          <div v-else>
            <a
              :href="article.url"
              @click.native="redirectToArticle(article.name)"
            >{{ article.name }}</a>
          </div>
        </div>
        <div class="article-description-container">
          <p v-html="showDescription(article)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import filter from "../../utils/filter";
import { mapGetters, mapMutations } from "vuex";
import * as CONSTANTS from "@/store/constants";
import moment from "moment";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

library.add({ faEye, faCalendarAlt });

export default {
  name: "KnowledgeBlockArticle",
  computed: {
    ...mapGetters(["platformCategory", "currentCategory"]),
    truncatedContent: function() {
      const ellipsis = "...";
      const truncateLength = 45;
      return content =>
        filter.hhTruncateHTML(content, truncateLength, ellipsis);
    },
    titleCased() {
      return title =>
        `${title
          .toUpperCase()
          .trim()
          .charAt(0)}${title
          .toLowerCase()
          .trim()
          .substring(1)}`;
    },
    showDescription() {

      return article =>
      {
        let description = article.content ? this.truncatedContent(article.content) : article.shortDescription
        return description &&  description.trim().length > 0 ?  description:article.name;
      };


    },
    updatedDifference() {
      return article => moment(article.updatedAt).fromNow();
    },
    articleRoute() {
      return articleId => `/${this.platformCategory}/articles/${articleId}`;
    }
  },
  props: {
    title: String,
    customArticles: Array,
    showReferenceText: Boolean,
  },
  methods: {
    ...mapMutations(["setCurrentCategory", "setInputFilter"]),
    redirectToArticle(articleName) {
      this.setCurrentCategory(undefined);
      this.setInputFilter("");
      this.$hhMixpanel.trackEvent(
        `${this.platformCategory} Knowledge Article - ${articleName}`
      );
    }
  }
};
</script>

<style scoped>
.knowledge-block-articles h2 {
  font-size: 26px;
  line-height: 25px;
  color: #000000;
  font-weight: 600;
  font-family: artifaktElementBold;
}

.article-title-container a {
  font-size: 16px;
  color: #0696d7;
  font-weight: bold;
  line-height: 20px;
  cursor: pointer;
  text-decoration: none;
}

.article-title-container a:hover {
  color: var(--secondary-color-hover);
}

.article-description-container p,
.article-info-container span {
  font-size: 16px;
  line-height: 20px;
  color: #000000;
}

.article-description-container p {
  margin-bottom: 0.6rem;
}

.article-info-container span {
  color: #717171;
}
</style>


// WEBPACK FOOTER //
// src/components/knowledge-article/KnowledgeBlockArticle.vue